<template lang="html">
  <b-navbar class="fixed-top" toggleable="md" type="dark" variant="info">
    <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center">
      <a class="navbar-brand brand-logo" href="/ccb/"><LogoSvg class="svgObject"/></a>
      <a class="navbar-brand brand-logo-mini" href="/ccb/"><LogoSvgMini class="svgObject"/></a>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
      <template v-if="loginSuccess">
        <b-navbar-nav class="header-links d-none d-md-flex" v-if="userHasAtLeast2Apps">
          <b-nav-item href="#" :active="isCcAdm" @click="$router.push('/interface_labels?action=search&activeGroup=Main Window')" v-if="user.ccadmEnabled"><i class="mdi mdi-console"></i>CCADMIN</b-nav-item>
          <b-nav-item href="#" :active="isPriceConf" @click="$router.push('/price_configurator/')" v-if="user.priceConfEnabled && hasCountries"><i class="mdi mdi-cash-usd"></i>Price Configurator</b-nav-item>
          <b-nav-item href="#" :active="isPriceConf" @click="userNotAllowedModal();" v-else-if="user.priceConfEnabled && !hasCountries"><i class="mdi mdi-cash-usd"></i>Price Configurator</b-nav-item>
          <b-nav-item href="#" :active="isPackConf" @click="$router.push('/pack_configurator/')" v-if="user.packConfEnabled"><i class="mdi mdi-package-variant-closed"></i>Pack Configurator</b-nav-item>
          <template v-if="isSolServiceActive">
            <b-nav-item href="#" :active="isSolModel" @click="$router.push('/sol_model/')" v-if="isSolServiceActive && user.solEnabledFrontEnd && !user.isDealer"><i class="mdi mdi-car"></i>{{getSolLabel}} </b-nav-item>
          </template>          
          <template v-else>
            <b-nav-item href="#" :active="isFinco" @click="$router.push('/sol_country/')" v-if="!user.isDealer"><i class="mdi mdi-car"></i>{{getSolLabel}} </b-nav-item>
          </template>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav :class="'ml-auto row col-lg-' + (isPriceConf?'3':'5')">
          <div class="row col-lg-12" v-if="isCcAdm || isPriceConf">
            <span class="col-lg-2 col-sm-0"></span>
            <b-form-select v-model="language" :options="languages" :class="'col-lg-' + (isCcAdm?'4':'6') + ' col-sm-' + (isCcAdm?'4':'6')"></b-form-select>
            <b-form-select v-if="isCcAdm" v-model="model" class="col-lg-4 col-sm-5">
              <b-form-select-option value="DEFAULT">DEFAULT</b-form-select-option>
              <b-form-select-option v-for="modelObj in getFullModelList" :id="'option_'+modelObj.modelcode" :value="{modelcode:modelObj.modelcode,modelId:modelObj.modelId}">{{modelObj.modelcode}} - {{modelObj.modelId}}</b-form-select-option>
            </b-form-select>
            <span style="padding-top: 0.6rem !important; cursor: pointer;" class="col-lg-2 col-sm-3" @click="logout">Logout</span>
          </div>
          <div class="row col-lg-12" v-else>
            <span class="col-lg-10 col-sm-1"></span>
            <span style="padding-top: 0.6rem !important; cursor: pointer;" class="col-lg-2 col-sm-11"  @click="logout">Logout</span>
          </div>
        </b-navbar-nav>
        <button class="navbar-toggler navbar-toggler-right align-self-center" type="button" @click="collapsedMobileSidebar()">
          <span class="mdi mdi-menu"></span>
        </button>
      </template>
      <template v-else>
        <b-navbar-nav class="header-links d-none d-md-flex">
          <b-nav-item href="#" :active="isLanding" @click="$router.push('/landing')"><i class="mdi mdi-earth"></i>Landing page</b-nav-item>
        </b-navbar-nav>
      </template>
    </div>
  </b-navbar>
</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
import LogoSvg from '../../assets/images/LogoSvg.vue'
import LogoSvgMini from '../../assets/images/LogoSvgMini.vue'
export default {
  name: 'app-header',
  methods: {
    collapsedMobileSidebar: () => {
      document.querySelector('.sidebar').classList.toggle('active')
    },
    userNotAllowedModal(){
     this.$bvModal.msgBoxOk('Not Allowed', {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              }) 
    },
    checkSolServiceStatus() {
      this.axios
        .get('/ccb/auth/fe/consoleConfig/getValue/SOL_SERVICE_AVAILABLE', {
          params: null,
          ...this.authHeader
        }
        )
        .then((response) => {
          this.setSolServiceActive(false)
          if(new String(response.data).toLowerCase() =='true')
            this.setSolServiceActive(true)
        });

    },
    ...mapActions([
      'setCurLanguage',
      'setCurModel',
      'setCurrentModelId',
      'logout',      
      'setSolServiceActive'
    ])
  },
  data () {
    return {
      model:null,
      language:null,
      priceConfigOk:this.hasCountries,
      packConfEnabledOk:(this.$store.state.user && this.$store.state.user.countries && this.$store.state.user.countries.length && this.$store.state.user.countries.length>=1),
      labels: {
              'header.fincoLabel': 'Setup FINCO taxes',
              'header.solSetupLabel': 'Setup SOL'
            }
    }
  },
  created() {
    this.model = this.curModel
    this.language = this.curLanguage
  },
  computed: {
    isPriceConfigOk () {
      return this.priceConfigOk
    },
    getSolLabel() {
      return (this.isSolServiceActive) ? this.labels['header.solSetupLabel'] : this.labels['header.fincoLabel']
    },
    isSolServiceActive() {
      return this.getSolServiceActive
    },
    ...mapState([
      'curLanguage',
      'curModel',
      'languages',
      'models',
      'loginSuccess',
      'user'
    ]),
    ...mapGetters([
      'getFullModelList',
      'isCcAdm',
      'hasCountries',
      'getLastSearch',
      'isPriceConf',
      'isPackConf',
      'isSolModel',
      'isLanding',
      'userHasAtLeast2Apps',
      'getSolServiceActive',
      'isFinco'

    ])
  },
  watch: {
    model(newValue,oldValue){
      if(this.getFullModelList.length){
        if (newValue != 'DEFAULT') {
           let modelObj = this.findElementByModelCodeAndModelId(this.getFullModelList,newValue);
           let mId = modelObj.modelId;
           let mCd = modelObj.modelcode;
           localStorage.setItem('currentvetelel',  mId);
           localStorage.setItem('currentModel', mCd);
           this.setCurrentModelId(mId)
           this.setCurModel(mCd);
        } else {
          this.setCurrentModelId('DEFAULT')
          this.setCurModel('DEFAULT');
        }
      }
      if (this.getLastSearch != null) {
        this.$nextTick(() => {
          this.getLastSearch();
        })
      }
    },
    language(newValue,oldValue){
      this.setCurLanguage(newValue);
      if (this.getLastSearch != null) {
        this.$nextTick(() => {
          this.getLastSearch();
        })
      }
    },
    '$store.state.curLanguage': function(newValue,oldValue) {
      this.language = newValue;
    }
  },
  components: {
    LogoSvg,
    LogoSvgMini
  }
}
</script>

<style scoped lang="scss">
.custom-select {
  border-color: transparent;
  background-color: transparent;
}
</style>
